<template>
    <div class="content-wrapper">
        <div class="row mb-primary">
            <div class="col-12">
                <!-- <div class="d-flex justify-content-between mb-3">
                    <copy-button id="titled-card" :value="titledCardValue"/>
                </div> -->

                <div class="card card-with-search border-0 card-with-shadow">
                    <div class="card-header align-items-center p-primary bg-transparent">
                        <h5 class="card-title d-inline-block mb-0">{{$t('documentlibrary_report')}}</h5>
                        <div class="float-right">
                            <a href="/admin/documentlibrary" class="btn btn-primary">Back</a>
                        </div>

                    </div>
                    <div class="card-body">
                        <!-- <div class="text-justify">
                            {{$t('card_content')}}
                        </div> -->
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <h1>Cosmo</h1>

                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <h4 class="font-weight-bold">Cosmo Medical</h4>
                                <p>(Medical Company)</p>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <p class="font-weight-bold mb-0">Address: ENGLAND LONDON UK</p>
                                <p class="font-weight-bold mb-0">Landline: 001-2222-3333</p>
                                <p class="font-weight-bold mb-0">Web: www.xyzsecurity.co.uk</p>
                                <p class="font-weight-bold mb-0">Email: info@xyzsecurity.co.uk</p>
                                <p class="font-weight-bold">Company Registration No: 11133265</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 text-center mb-3">
                                <h5 class="font-weight-bold">Incident Report</h5>
                            </div>
                        </div>
                        <div class="row">
                           <div class="col-lg-12 col-md-12 col-sm-12">
                                <form ref="form" data-url="" class="mb-0" :class="{'loading-opacity': preloader}">
                                    <div class="form-group row align-items-center">
                                        <div class="col-lg-6 col-md-6 col-sm-6 ">
                                            <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('name') }}
                                            </label>
                                            <app-input id="name_input"
                                                    class="col-sm-12"
                                                    type="text"
                                                    v-model="inputs.name_input"
                                                    :placeholder="$t('text_type_input')"/>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 ">
                                            <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('email') }}
                                            </label>
                                            <app-input id="email_input"
                                                    class="col-sm-12"
                                                    type="email"
                                                    v-model="inputs.email_input"
                                                    :placeholder="$t('text_type_input')"/>
                                        </div>
                                    </div>
                                    <div class="form-group row align-items-center">
                                        <div class="col-lg-6 col-md-6 col-sm-6 ">
                                            <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('address') }}
                                            </label>
                                            <app-input id="address_input"
                                                    class="col-sm-12"
                                                    type="text"
                                                    v-model="inputs.address_input"
                                                    :placeholder="$t('text_type_input')"/>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6 ">
                                            <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('phone') }}
                                            </label>
                                            <app-input id="phone_input"
                                                    class="col-sm-12"
                                                    type="text"
                                                    v-model="inputs.phone_input"
                                                    :placeholder="$t('text_type_input')"/>
                                        </div>
                                    </div>
                                    <div class="form-group mb-primary row align-items-center">
                                        <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('default_upload') }}
                                            </label>
                                        <div class="col-sm-12 default-file">
                                            <app-input type="file"
                                                    :label="$t('upload_your_file')"
                                                    v-model="inputs.default_file"/>
                                            <small class="text-muted font-italic">
                                                {{ $t('recommended_default_file_validation') }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group row align-items-center">
                                        <div class="col-lg-12 col-md-12 col-sm-12 ">
                                            <label for="text_input" class="col-sm-2 mb-sm-0">
                                                {{ $t('report') }}
                                            </label>
                                            <app-input id="report_input"
                                                    class="col-sm-12"
                                                    type="text"
                                                    v-model="inputs.report_input"
                                                    :placeholder="$t('text_type_input')"/>
                                        </div>
                                    </div>
                                    
                                    <div class="mt-5 action-buttons">
                                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                                            {{ $t('download') }}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import GlobalHelperMixin from '../../../../Mixins/global/GlobalHelperMixin';

export default {
        mixins: [FormMixin, GlobalHelperMixin],
        data() {
            return {
                inputs: {},
                preloader: false,
            }
        }
}
</script>
